<template>
    <div class="content">
        <div class="siftitem">
            <div class="bigtitle">
                <p>精选品类</p>
            </div>
            <div class="sift">
                <div class="item" :id="'item'+item.id" v-for="(item, index) in typeList" :key="item.id">
                    <div class="itemclass">
                        <p @mouseover="lookClassGoods(index, item.id)">{{ item.cateName }}</p>
                        <span @mouseover="lookClassGoods(index, itemc.id)" v-for="itemc in item.children.slice(0, 4)"
                            :key="itemc.id" :class="itemc.id === currGoodsClass[index] ? 'spancurr' : ''">
                            {{ itemc.cateName }}
                            <i class="iconfont icon-xiangyou"></i>
                        </span>
                        <div class="classimg">
                            <img :src="item.pic">
                        </div>
                    </div>
                    <div class="itembody">
                        <template v-if="showGoodsList[index].length == 0">
                            <div style="width:100%;display: flex;justify-content: center;">
                                <el-empty description="暂无商品"></el-empty>
                            </div>
                        </template>
                        <template v-else>
                            <div v-for="(goods, gIndex) in showGoodsList[index]" :key="gIndex" class="itemb" @click="clickGood(goods.id,0)">
                                <div class="itemimg">
                                    <img :src="goods.image">
                                </div>
                                <div class="itemtext">
                                    <span :title="goods.storeName">{{ goods.storeName }}</span>
                                </div>
                                <div class="itempic">
                                    <i>￥</i>
                                    <span>{{ goods.price }}</span>
                                    <b>/{{ goods.unitName }}</b>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div></template>
<script  name='siftitem'>
import {
    getProducts
} from '@/api/indexpage.js'
import store from '@/store'
import { getToken } from '@/axios/cookies.js'
import { getCates } from '@/api/noticedetail.js'
export default {
    props: { obj: Object },
    data() {
        return {
            //当前选择的分类
            currGoodsClass: [],
            //当前显示的商品的分类
            currShowGoodsClass: [],
            //展示的商品
            showGoodsList: [],
            goodType: [],
            goodList: [],
            //第二级菜单分类
            typeList: [],

        }
    },
    mounted() {
        this.getTypeList()
    },
    methods: {
        // 商品分类
        async getTypeList() {
            var res = await getCates()
            // 循环分类指定每个分类选中的分类
            res.data[0].children.forEach((item) => {
                this.currGoodsClass.push('');
                this.currShowGoodsClass.push(item.id);
                this.showGoodsList.push([])
            });
            //分类
            this.typeList = res.data[0].children;
            this.getProList()
        },
        //查看商品
        lookClassGoods(index, id) {
            //设置选中的标识
            this.currGoodsClass.splice(index, 1, id);
            this.getGoodsList({isIntegral:0,news:0,sid:id,limit:4,page:1},index);
        },
        // 首次打开批量获取商品
        async getProList() {
            //获取默认列表商品
            this.currShowGoodsClass.forEach(async (cid, index) => {
                let listquery = {
                    'isIntegral': 0, // 是否积分兑换商品 0否  1是
                    'news': 0, // 是否新品  0否  1是
                    'sid': cid, // 分类ID
                    'limit': 4,
                    'page': 1
                }
                this.getGoodsList(listquery,index)
            })
        },
        //获取商品列表
        async getGoodsList(listquery,index) {
            let res = await getProducts(listquery)
            if (res.status === 200) {
                const token = getToken()
                if (token === undefined) {
                    res.data.forEach((item) => {
                        item.price = '登录查看';
                    });
                }
                this.showGoodsList[index].length = 0
                this.showGoodsList[index].push(...res.data)
            }
        },
        clickGood(id, type) {
            this.$router.push({
                path: '/productDetail',
                query: {
                    productId: id,
                    type: type
                }
            })
        }
    },
}

</script>
<style scoped lang='less'>
/* scoped 使用得定义的样式只在本页面内生效  */
.content {
    width: 100%;

    .siftitem {
        width: 1440px;
        margin: 0 auto;

        .bigtitle {
            width: 100%;

            p {
                font-size: 20px;
                color: #333;
                text-align: left;
            }
        }

        .sift {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 20px 0;

            .item {
                box-sizing: border-box;
                width: 49%;
                height: 650px;
                margin: 10px 5px;
                display: flex;
                flex-wrap: nowrap;

                .itemclass {
                    position: relative;
                    width: 30%;
                    height: 100%;
                    background-color: #D3D3D3;
                    background: url('../../../../../static/index/20221222095130936.png') no-repeat;
                    background-size: 100% 100%;
                    padding: 20px;
                    cursor: pointer;

                    p {
                        font-size: 20px;
                        font-weight: 700;
                        color: #2c3038;
                        margin-bottom: 60px;
                        cursor: mouseover;
                    }

                    span {
                        display: block;
                        font-size: 15px;
                        color: #55575a;
                        margin: 30px 0;
                        cursor: pointer;

                        i {
                            display: inline;
                            vertical-align: text-bottom;

                        }

                        &:hover {
                            color: #2c3038;
                            font-weight: 900;

                            i {
                                display: inline;
                                vertical-align: text-bottom;
                            }
                        }
                    }

                    .spancurr {
                        color: #2c3038;
                        font-weight: 900;

                        i {
                            display: inline;
                            vertical-align: text-bottom;
                        }
                    }

                    .classimg {
                        position: absolute;
                        bottom: 100px;
                        right: 0px;
                        width: 100%;
                        height: 100px;

                        img {
                            width: 100%;
                            height: auto;
                        }
                    }
                }

                .itembody {
                    width: 70%;
                    height: 100%;
                    background-color: #fff;
                    display: flex;
                    flex-wrap: wrap;
                    // justify-content: center;

                    .itemb {
                        width: 50%;
                        height: 325px;
                        padding: 10px;
                        box-sizing: border-box;
                        cursor: pointer;

                        &:hover {
                            box-shadow: 0 0 5px 0 rgba(0, 0, 0, .2);

                            .itemtext {
                                color: #f74747;
                            }

                        }

                        .itemimg {
                            width: 100%;
                            height: 200px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        &:nth-child(1) {
                            border-right: 1px solid #efefef;
                            border-bottom: 1px solid #efefef;
                        }
                        &:nth-child(2) {
                            border-bottom: 1px solid #efefef;
                        }
                        &:nth-child(3) {
                            border-right: 1px solid #efefef;
                        }

                        .itemtext {
                            width: 100%;
                            height: 36px;
                            line-height: 18px;
                            font-size: 14px;
                            margin: 15px 0;
                            color: #333;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            cursor: pointer;
                        }

                        .itempic {
                            width: 100%;
                            line-height: 36px;

                            i {
                                font-size: 14px;
                                color: #f74747;
                                font-style: normal;
                            }

                            span {
                                font-weight: 900;
                                color: #f74747;
                                font-size: 20px;
                            }

                            b {
                                font-size: 14px;
                                color: #333;
                                font-weight: 400;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
 


// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/SiftItem.vue